import React from 'react';
import { Link } from 'react-router-dom';
import { useCart } from './Cart';
import { FaShoppingCart } from 'react-icons/fa';

function Header() {
  const { getTotalItems, setIsCartOpen } = useCart();

  return (
    <header className="header">
      <Link to="/" className="logo">
        <img src="/image.png" alt="Дух Приморья" className="logo-img" />
        <span>Дух Приморья</span>
      </Link>
      <nav className="nav">
        <Link to="/">Главная</Link>
        <Link to="/catalog">Каталог</Link>
        <a href="/#gifts">В подарок</a>
        <button className="cart-icon" onClick={() => setIsCartOpen(true)}>
          <FaShoppingCart />
          {getTotalItems() > 0 && <span className="cart-badge">{getTotalItems()}</span>}
        </button>
      </nav>
    </header>
  );
}

export default Header;
